import { ComponentType } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class UIDialogService {
  private readonly dialog = inject(MatDialog);


  open<T>(component: ComponentType<T>, config?: MatDialogConfig): void {
    this.dialog.open(component, { maxWidth: 'calc(100vw - 2rem)', ...config });
  }
}
